import styles from 'styled-components';

const RowSm = styles.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;

    > div {
      padding: 0 10px;
    }
`;

export default RowSm;
